import { Identity } from 'embedded/api/out/Identity';
import { Listener } from 'embedded/api/out/Listener';
import { Store } from 'redux';
import { selectLayout } from 'layout/store/selectors';
import { v4 as uuid } from 'uuid';
import { OutMessage, OutMessagePayload } from 'embedded/api/out/OutMessage';
import { OutMessageTopic } from 'embedded/api/out/OutMessageTopic';

export interface LayoutLoadedMessagePayload extends OutMessagePayload {
    layoutName: string;
}

export type LayoutLoadedMessage = OutMessage<
    'LAYOUT_LOADED',
    LayoutLoadedMessagePayload
>;

export const layoutLoadedTopic: OutMessageTopic<LayoutLoadedMessagePayload> = {
    subscriptions: [],
    publishOnSubscribe: layoutLoadedPublishOnSubscribe,
};

export function layoutLoadedPublishOnSubscribe(
    identity: Identity,
    listener: Listener<LayoutLoadedMessagePayload>,
    store: Store
): void {
    const layoutState = selectLayout(store.getState());
    if (layoutState) {
        listener({ layoutName: layoutState.name, correlationId: uuid() });
    }
}
